import './css/main.scss';

import './js/scroll-animations';
